import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'baseIsEmpty' })
export class BaseIsEmptyPipe implements PipeTransform {
  transform(value: unknown, replaceText: string = '-'): unknown {
    return !!value ? value : replaceText;
  }
}
